"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextType = void 0;
var ContextType;
(function (ContextType) {
    ContextType[ContextType["Local"] = 0] = "Local";
    ContextType[ContextType["Authenticated"] = 1] = "Authenticated";
    ContextType[ContextType["Anonymous"] = 2] = "Anonymous";
})(ContextType || (exports.ContextType = ContextType = {}));
//# sourceMappingURL=ContextType.js.map